var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgTextPaint = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: [_jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M14.333 4.204c.886 0 1.604.719 1.604 1.605v.895a2 2 0 0 1-2 2H11a2 2 0 0 0-2 2v.25" }), _jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M14.063 2.33h-10.5v3.75h10.5zm-4.75 8.09h-.626a1 1 0 0 0-1 1v3.25a1 1 0 0 0 1 1h.626a1 1 0 0 0 1-1v-3.25a1 1 0 0 0-1-1Z" })] }))); };
export default SvgTextPaint;
